module.exports = __webpack_public_path__ + "img/grey-cross.2a821057.svg";